module.exports = __webpack_public_path__ + "img/part_6_6.1eb7e4b6.webp";